<template>
    <div>
        <div class="content-header">
            <ol class="breadcrumb">
                <li class="active">角色关联用户</li>
            </ol>
        </div>
<!--         <div class="content-operator content-border">
            <router-link :to="{ name: 'roleDetail' }" class="btn btn-info">添加</router-link>
        </div> -->
        <div class="content-query content-border">
            <form action="" class="form-inline">
                <div class="form-group">
                    <button type="button" class="btn btn-info" @click="submitQuery(1)">刷新</button>
                    <button type="button" class="btn btn-default" onclick="window.history.go(-1);">返回</button>
                </div>
            </form>
        </div>
        <div class="content-data" v-if="0 < userRoles.length">
            <table class="table table-hover table-bordered">
                <thead>
                    <tr>
                        <th>序号</th>
                        <th>角色名称</th>
                        <th>账户</th>
                        <!-- <th>操作</th> -->
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in userRoles" :key="index">
                        <td v-text="index+1"></td>
                        <td v-text="item.name"></td>
                        <td v-text="item.username"></td>
<!--                         <td>
                            <span @click="deleteUserRole(item.userRoleId)" class="btn btn-danger btn-xs">删除</span>
                        </td> -->
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="content-data" v-else>
            没有查询到数据
        </div>
        <vue-pager v-bind:datafile="fillData" url="/userRole/pageUserRole" v-bind:query="query" ref="pager" v-bind:init="true"></vue-pager>
    </div>
</template>
<script>
export default {
    data() {
        return {
            userRoles: [],
            query: {
            },
                
        }
    },
    created() {
        var _this = this;
        _this.roleId = _this.$route.query.roleId;
        _this.query.roleId = _this.$route.query.roleId;
        console.log(_this.query.roleId);
    },
    methods: {
        fillData(_response) {
            var _this = this;
            if(_response.items){
                _this.userRoles = _response.items ||[];
            }
        },
        submitQuery(_num) {
            var _this = this;
            _this.userRoles = [];
            _this.$refs.pager.gotoPage(_num);
        },
        deleteUserRole: function(_userRoleId) {
            var _this = this;
            _this.$confirm('是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                _this.$common.my_ajax({
                    url: 'userRole/deleteUserRole',
                    data: {
                        userRoleId: _userRoleId
                    },
                    success: function(response) {
                        _this.$message({
                            message: '删除成功',
                            type: 'success',
                            duration: 1000,
                            onClose: function() {
                                _this.submitQuery();
                            }
                        });
                    }
                });
            }).catch(() => {
                console.log('取消删除');
            });
        },
    }
}
</script>
<style scoped>
td {
    text-align: center;
}
.table tr th{
    text-align: center; 
}
</style>